import React, { Dispatch, SetStateAction } from 'react';
import { TypeOfUsers } from 'types';
import BulkActionComponent from '../../bulkActionFlow/BulkActionComponent';
import { BiSelectMultiple } from 'react-icons/bi';
import { Button } from 'flowbite-react';
import { useSearchParams } from 'react-router-dom';
import UseKeyBoardShortCut from 'src/utils/UseKeyBoardShortCut';

const BulkSelectAction = ({
	typeOfUsers,
	bulkSelectedIds,
	setBulkSelectedIds,
}: {
	typeOfUsers: TypeOfUsers | string;
	bulkSelectedIds: string[];
	setBulkSelectedIds: Dispatch<SetStateAction<string[]>>;
}) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const bulkSelect = searchParams.get('bulkSelect') === 'true';
	UseKeyBoardShortCut(
		'#bulk-select-action',
		{ metaKey: true, key: 'b' },
		(element: HTMLElement | Document | React.RefObject<HTMLElement>) => {
			setBulkSelectedIds([]);
			if (!bulkSelect) {
				searchParams.set('bulkSelect', (!bulkSelect)?.toString());
			} else {
				searchParams.delete('bulkSelect');
			}
			setSearchParams(searchParams);
		},
	);

	return (
		<>
			{/* Bulk Select */}
			<Button
				onClick={() => {
					setBulkSelectedIds([]);
					if (!bulkSelect) {
						searchParams.set('bulkSelect', (!bulkSelect)?.toString());
					} else {
						searchParams.delete('bulkSelect');
					}
					setSearchParams(searchParams);
				}}
				className={`walkthrough-fourth-element ${
					bulkSelect
						? 'text-white hover:!bg-[#1C1C28] bg-[#1C1C28] hover:dark:!bg-white dark:bg-white dark:text-black'
						: 'text-[#1C1C28]'
				} rounded-[8px] p-[8px] [&>span]:!p-0`}
				color="light"
			>
				<BiSelectMultiple className="w-[24px] h-[24px]" />
			</Button>
			<BulkActionComponent
				typeOfUsers={typeOfUsers}
				allIds={bulkSelectedIds}
				bulkSelectedIds={bulkSelectedIds}
				setBulkSelectedIds={setBulkSelectedIds}
			/>
		</>
	);
};

export default BulkSelectAction;
